export const ANSWER = 'answer-'
export const CHECKBOX = 'checkbox-'
export const CONTENT_TYPE = { id: 'interactivemcms' }
export const DATA_TEST_ID_PREFIX = 'multi-select-'
export const TEXT_AREA = 'textarea-'
